module.exports = __webpack_public_path__ + "img/long.06ff7108.png";